// RouteChangeCanceler.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AxiosRequestManager } from '../../utils/AxiosRequestManager';

const RouteChangeCanceler = () => {
  const location = useLocation();

  useEffect(() => {
    // Cancel all pending API requests on route change
    AxiosRequestManager.cancelAll();
  }, [location]);

  return null; // No UI, just a logic component
};

export default RouteChangeCanceler;
